export default __webpack_public_path__ + "static/media/gallery-7.27e3ad86.jpg";